'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = 'src/payment-pages/notification-telephone.js';
exports.NotificationTelephone = NotificationTelephone;
exports.NotificationTelephoneFromTheme = NotificationTelephoneFromTheme;
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _glamorous = require('glamorous');
var _notificationPage = require('./notification-page');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
NotificationTelephone.propTypes = {
  telephone: _propTypes.string.isRequired
};
function NotificationTelephone(_ref) {
  var telephone = _ref.telephone;
  return _react2.default.createElement(_notificationPage.BigLink, {
    href: 'tel: ' + telephone.replace(/\s/g, ''),
    __source: {
      fileName: _jsxFileName,
      lineNumber: 11
    },
    __self: this
  }, telephone);
}
function NotificationTelephoneFromTheme(_ref2) {
  var theme = _ref2.theme;
  return _react2.default.createElement(NotificationTelephone, {
    telephone: theme.telephone,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 15
    },
    __self: this
  });
}
exports.default = (0, _glamorous.withTheme)(NotificationTelephoneFromTheme);